import React from 'react';
import { IMAGES } from '../mock';
import { Home, Building2, ShieldCheck, PackageCheck } from 'lucide-react';

export default function FreePickup() {
  const items = [
    { icon: Home, title: 'ઘરેથી પિકઅપ', desc: 'આરામથી તમારા ઘરેથી' },
    { icon: Building2, title: 'ઓફિસથી પિકઅપ', desc: 'કામની ચિંતા વગર' },
    { icon: ShieldCheck, title: 'સલામત સર્વિસ', desc: 'સુરક્ષિત અને ભરોસાપાત્ર' },
    { icon: PackageCheck, title: 'ઝંઝટ-મુક્ત', desc: 'કોઈ પરેશાની નહીં' },
  ];
  return (
    <section className="relative py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-3xl overflow-hidden card-dark grid md:grid-cols-2">
          <div className="relative h-64 md:h-auto">
            <img src={IMAGES.pickup} alt="pickup drop" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0f0f16] via-[#0f0f16]/50 to-transparent md:bg-gradient-to-r" />
          </div>
          <div className="p-7 md:p-10">
            <div className="tag-pill mb-4">ફ્રી સેવા</div>
            <h2 className="text-3xl md:text-4xl font-extrabold">
              <span className="text-white">ફ્રી </span><span className="gradient-text">પિકઅપ & ડ્રોપ</span>
            </h2>
            <p className="mt-3 text-gray-400">સમગ્ર વડોદરામાં — તમામ AMC અને પેકેજ માટે બિલકુલ ફ્રી.</p>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {items.map((it, i) => (
                <div key={i} className="flex items-start gap-3 rounded-xl border border-purple-900/40 bg-[#14141c] p-3">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{background:'linear-gradient(135deg,rgba(168,85,247,.18),rgba(236,72,153,.18))',border:'1px solid rgba(168,85,247,.35)'}}>
                    <it.icon className="w-4 h-4 text-pink-400" />
                  </div>
                  <div>
                    <div className="text-white text-sm font-semibold">{it.title}</div>
                    <div className="text-xs text-gray-400">{it.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
